import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0e8514d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown-select-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "focus" }, null, -1))
const _hoisted_3 = { class: "dropdown-select__trigger" }
const _hoisted_4 = { class: "dropdown-default-answer" }
const _hoisted_5 = { class: "dropdown-options" }
const _hoisted_6 = { "data-test": "cms-dropdown-options" }
const _hoisted_7 = ["onClick", "data-test"]

import axios from "axios";
import { debug as d } from "debug";
import { computed, ref } from "vue";
import { SessionQuestionnaireApiModel } from "../../api-models";

export interface AnswerData {
  answerId: string;
  answerLabel: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-dropdown',
  props: {
    answers: {},
    isShuffle: { type: Boolean },
    dropdownId: {},
    questionnaire: {}
  },
  setup(__props: any) {

const debug = d("cs.CmsDropdown");

const props = __props;

const isOpen = ref(false);

const previouslySelectedAnswer = computed<AnswerData | undefined>(() => {
  const previousAnswer: string[] | undefined = props.questionnaire.answers[props.dropdownId];
  const answerId = previousAnswer ? previousAnswer[0] : undefined;
  return props.answers.filter((answer) => answer.answerId === answerId)[0];
});

const selectedAnswer = ref<AnswerData | undefined>(previouslySelectedAnswer.value);

function shuffleArray(array: AnswerData[]): AnswerData[] {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
}

const answers = computed(() => {
  return props.isShuffle ? shuffleArray(props.answers) : props.answers;
});

function openDropdownHandler(): void {
  isOpen.value = !isOpen.value;
}

function inputHandler(answer: AnswerData): void {
  debug(answer.answerId);
  selectedAnswer.value = answer;
  axios
    .patch(`/api/sessionquestionnaire/${props.questionnaire?.id}/answers`, {
      [props.dropdownId]: [answer.answerId],
    })
    .then((resp) => {
      if (resp.status === 200) {
        debug("success!");
      }
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      "data-test": "cms-dropdown",
      class: _normalizeClass(["dropdown-select", isOpen.value ? 'open' : '']),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (openDropdownHandler()))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(selectedAnswer.value?.answerLabel || "Pick an option"), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answers.value, (data, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("span", {
                class: _normalizeClass(["dropdown-option", data.answerId === selectedAnswer.value?.answerId ? 'dropdown-option selected' : '']),
                onClick: ($event: any) => (inputHandler(data)),
                "data-test": `cms-dropdown-option-${index}`
              }, _toDisplayString(data.answerLabel), 11, _hoisted_7)
            ]))
          }), 128))
        ])
      ])
    ], 2)
  ]))
}
}

})